
(() => {
    // 发送集合页浏览埋点数据
    pptag.send('page_view', {
        page_type: 'CATEGORY',
        page_path: '{{ collection.handle }}',
        page_category_name: '{{ collection.title }}',
    });

    // YouTube视频iframe包装器脚本
    const iframes = document.getElementsByTagName('iframe');
    Array.from(iframes).forEach((iframe) => {
        if (iframe.src.includes('youtube.com')) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('video-wrapper');
            iframe.parentNode.insertBefore(wrapper, iframe);
            wrapper.appendChild(iframe);
        }
    });

    // Google Analytics电商跟踪脚本
    const trackAddToCart = () => {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'collection_add_to_cart_button', {
                event_category: 'Ecommerce',
                event_label: 'Collection Add to Cart Button',
                value: 1,
            });
        }
    };
    const bindAddToCartButton = (button) => {
        if (button && !button.dataset.tracked) {
            button.addEventListener('click', trackAddToCart);
            button.dataset.tracked = 'true';
        }
    };
    document.addEventListener('DOMContentLoaded', () => {
        // 绑定现有的加购按钮
        document.querySelectorAll('form[is="product-form"] button[type="submit"]').forEach(bindAddToCartButton);

        // 事件委托处理动态按钮
        document.addEventListener('click', (event) => {
            if (event.target && (event.target.id === 'AddToCart' || event.target.closest('[id="AddToCart"]'))) {
                trackAddToCart();
            }
        });

        // 监听动态内容变化
        const drawers = document.querySelectorAll('.drawer--quick-buy');
        drawers.forEach((drawer) => {
            new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) {
                                const buttons = node.querySelectorAll ? node.querySelectorAll('[id="AddToCart"]') : [];
                                buttons.forEach(bindAddToCartButton);
                            }
                        });
                    }
                });
            }).observe(drawer, { childList: true, subtree: true });
        });
    });
})()

